import api from './wasteManagementClient';
import { wasteManagementUrls as urls } from '../appConfig';
import { ISchema, ISchemaType } from '../models/Schema.model';

export default abstract class SurveyService {
  public static async getSchemaTypes(
    ignoreCache: boolean = false
  ): Promise<Array<ISchemaType>> {
    try {
      const params = { cache: { ignoreCache, maxAge: 1000 * 60 * 60 * 12 } };
      const response = await api.get(urls.surveyCreator + '/types', params);
      return response.status === 200 ? response.data : [];
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }

  public static async createSchemaType(
    created: ISchemaType
  ): Promise<ISchemaType> {
    try {
      const params = created;
      const response = await api.post(
        urls.surveyCreator + '/types/create',
        params
      );
      return response.status === 200 ? response.data : null;
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }

  public static async editSchemaType(
    updated: ISchemaType
  ): Promise<ISchemaType> {
    try {
      const params = updated;
      const response = await api.put(
        urls.surveyCreator + '/types/update',
        params
      );
      return response.status === 200 ? response.data : null;
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }

  public static async deleteSchemaType(
    deleted: ISchemaType
  ): Promise<ISchemaType> {
    try {
      const params = deleted;
      const response = await api.put(
        urls.surveyCreator + '/types/delete',
        params
      );
      return response.status === 200 ? response.data : null;
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }

  public static async getSurvey(id: number): Promise<ISchema> {
    try {
      const response = await api.get(urls.surveyCreator + `/${id}`, {
        cache: { ignoreCache: true },
      });
      return response.status === 200 ? response.data : null;
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }

  public static async saveSurvey(survey: ISchema): Promise<ISchema> {
    try {
      const params = survey;
      const response = await api.put(urls.surveyCreator + '/upsert', params);
      return response.status === 200 ? response.data : null;
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }
}
